document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-naya-style-filters]').forEach((filters) => {
    const library = document.querySelector('[data-naya-style-library]');
    if (!library) return;
    filters.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => {
      const selected = button.dataset.filter;
      filters.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      library.querySelectorAll('[data-type]').forEach((card) => {
        card.hidden = selected !== 'All' && selected !== card.dataset.type;
      });
    }));
  });
});
